import { render } from "./index.vue?vue&type=template&id=320e8a9e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=320e8a9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-320e8a9e"

export default script